import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useAuth } from 'src/hooks/use-auth';
import { useRouter } from 'src/hooks/use-router';
import { paths } from 'src/paths';
import { roles } from "src/roles";

export const GuestGuard = (props) => {
    const { children } = props;
    const { isAuthenticated, user } = useAuth();
    const router = useRouter();
    const [checked, setChecked] = useState(false);

    const check = useCallback(() => {
        if (isAuthenticated) {
            const params = new URLSearchParams(window.location.search);
            if (params.has('invite')) {
                router.replace(paths.dashboard.profile.information);
            } else if (user?.role === roles.WORKER) {
                router.replace(paths.cabinet.projects.find);
            } else {
                router.replace(paths.cabinet.projects.index);
            }
        } else {
            setChecked(true);
        }
    }, [isAuthenticated, user, router]);

    // Only check on mount, this allows us to redirect the user manually when auth state changes
    useEffect(() => {
        check();
    },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []);

    if (!checked) {
        return null;
    }

    // If got here, it means that the redirect did not occur, and that tells us that the user is
    // not authenticated / authorized.

    return <>{children}</>;
};

GuestGuard.propTypes = {
    children: PropTypes.node
};
